<template>
  <div class="idCardBinding">
    <!--顶部导航-->
    <Navbar title="资质认证" :isSpecialBack="true" @goBack="handleBack" />
    <!-- 信息收集进度条-->
    <progressField :currentStep="flag" />
    <div class="progress-block">

    </div>
    <div class="content">
      <!--身份证上传-->
      <div v-if="flag == 1">
        <idCardUpload ref="idCardUploadRef" @submitClick="handleSubmitClick" />
      </div>
      <!--添加联系人-->
      <div v-if="flag == 2">
        <addContact @confirm="handleConfirm" />
      </div>
      <!--个人信息-->
      <div v-if="flag == 3">
        <personalInformation @submitClick="handleResultClick" />
      </div>
      <!--结果页面-->
      <div v-if="flag == 4">
        <resultPage />
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import progressField from "@/components/progress/index.vue";
import idCardUpload from "@/components/idCardBinding/idCardUpload.vue";
import addContact from "@/components/idCardBinding/addContact.vue";
import personalInformation from "@/components/idCardBinding/personalInformation.vue";
import resultPage from "@/components/idCardBinding/resultPage.vue";
import { getLocalStorageData } from "@/common/index.js";
export default {
  name: "idCardBinding",
  components: {
    Navbar,
    progressField,
    idCardUpload,
    addContact,
    personalInformation,
    resultPage,
  },
  data() {
    return {
      isNavigatingAway: false,
      flag: 1,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "agreement" || from.name == "idCardLoading") {
        const preCheckData = getLocalStorageData("preCheckData");
        vm.flag = preCheckData.code == 10013 ? 3 : preCheckData.code == 10014 ? 2 : 1;
      } else {
        const preCheckData = getLocalStorageData("preCheckData");
        vm.$refs.idCardUploadRef && vm.$refs.idCardUploadRef.init();
        vm.flag = preCheckData.code == 10013 ? 3 : preCheckData.code == 10014 ? 2 : 1;
      }
    });
  },
  methods: {
    initHistoryListener() {
      window.removeEventListener("popstate", this.handleSafePopState);
      window.removeEventListener("hashchange", this.handleSafePopState);
      window.addEventListener("popstate", this.handleSafePopState);
      window.addEventListener("hashchange", this.handleSafePopState);

      if (!this._hasPushedState) {
        window.history.pushState({ __guard: true }, "", window.location.href);
        this._hasPushedState = true;
      }
    },
    // 统一卸载方法
    removeInterceptor() {
      window.removeEventListener("popstate", this.handleSafePopState);
      window.removeEventListener("hashchange", this.handleSafePopState);
      this._hasPushedState = false;
      this.isNavigatingAway = false;
    },
    // 1. 原生/Hash 物理返回拦截处理器
    handleSafePopState() {
      // 如果已经在跳转中了，直接熔断，不做任何操作
      if (this.isNavigatingAway) return;
      this.executeCustomNavigation();
    },

    // 2. 核心自定义跳转执行器（防轰炸）
    executeCustomNavigation() {
      if (this.isNavigatingAway) return;

      // 💡 步骤 A：立刻上死锁，后续任何高频 popstate/守卫 回调都将在第一行被 return 熔断
      this.isNavigatingAway = true;

      window.history.pushState({ __guard: true }, "", window.location.href);
      this.$router.push({ name: "Home" }).catch(() => {});
      setTimeout(() => {
        this.isNavigatingAway = false;
      }, 300);
    },
    handleBack() {
      this.$router.push({
        name: "Home",
      });
    },
    handleResultClick() {
      this.$router.push({ name: "result" });
    },
    handleSubmitClick() {
      const preCheckData = getLocalStorageData("preCheckData");
      this.flag = preCheckData.code == 10013 ? 3 : preCheckData.code == 10014 ? 2 : 1;
    },
    handleConfirm(contactInfo) {
      console.log(contactInfo, "contactInfo");
      this.flag = 3;
    },
  },
};
</script>

<style scoped lang="scss">
.idCardBinding {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f5f5f5;
}
.content {
  padding: 0px 16px;
}
.progress-block{
  height: 80px;
  width: 100%;
  background: transparent;
}
</style>
